/* eslint-disable indent */
import React, { FC } from "react"
import { useTranslation } from "next-i18next"
import styles from "../NewOlympiadGeneralStyles.module.scss"
import HeaderImg from "@cs/public/img/olympiad/home/olympiad_main.jpg"
import HeaderMobile from "@cs/public/img/olympiad/home/olympiad_main_mobile.jpg"
import HeaderSmallMobile from "@cs/public/img/olympiad/home/olympiad_main_small_mobile_new.png"
import BasicHero from "./NewBasicHero"
import { NextSeo } from "next-seo"
import { useDeviceSize } from "@climate-science/component-library"
import { changeRouteKeepParams } from "util/changeRouteKeepParams"
import { useRouter } from "next/router"
import Button from "@cs/components/olympiad/Button"
import Link from "next/link"
import { Balancer } from "react-wrap-balancer"

const OlympiadHero: FC = () => {
  const { t } = useTranslation(["olympiad", "_links", "seo"])
  const { isSmallMobile, isMobile } = useDeviceSize()
  const router = useRouter()

  const background = {
    src: HeaderImg,
    alt: "Climate Science Olympiad 2021 winners",
  }

  if (isMobile) {
    background.src = HeaderMobile
  }

  if (isSmallMobile) {
    background.src = HeaderSmallMobile
  }

  const children = (
    <>
      <p className={styles.p}>
        <Balancer>{t("win-a-trip")}</Balancer>
      </p>
      <div className={styles.buttons}>
        <Button
          onClick={() =>
            window.open(
              changeRouteKeepParams(`
              https://olympiad.${process.env.NEXT_PUBLIC_DOMAIN}${
                router.locale == "en" ? "" : "/" + router.locale
              }/signup`),
              "_blank",
            )
          }
          className={styles.register}
        >
          {t("start-here")}
        </Button>
        <Link href="olympiad/cso24">
          <a className={styles.a} target="_blank">
            {t("tell-more")}
          </a>
        </Link>
      </div>
    </>
  )

  return (
    <>
      <NextSeo
        title={t("olympiad-page.title", { ns: "seo" })}
        description={t("olympiad-page.description", { ns: "seo" })}
      />
      <BasicHero
        background={background}
        ns={"olympiad"}
        heading={"cs-olympiad"}
        lower
      >{children}
      </BasicHero>
    </>
  )
}

export default OlympiadHero
